<header>
  <div class="main-menu-container flex flex-row justify-between items-center">
    <div class="flex-auto">
      <img
        [src]="logoUrl()"
        width="250"
        height="60"
        [alt]="appTitle() + ' Logo'"
        id="header-logo"
      />
    </div>
    <div class="flex-auto flex justify-end main-menu-container__textbox">
      <h1>{{ appTitle() }}</h1>
    </div>
  </div>
  <mat-divider />

  <div>
    @if (loggedIn()) {
      <mat-toolbar class="mat-primary">
        <mat-toolbar-row class="flex flex-row flex-wrap">
          @if (currentUser(); as user) {
            <!-- Desktop Navigation Links -->
            <div class="hidden md:block">
              <div class="lighthouse-nav-links flex flex-row flex-wrap">
                @if (isRater()) {
                  <span>
                    <button id="survey-dashboard" matButton routerLink="/rater">
                      <mat-icon>dashboard</mat-icon>&nbsp;Survey Dashboard
                    </button>
                  </span>
                }
                @if (hasAccess(resourceEnum.Admin, rightsEnum.Read)) {
                  <span>
                    <button matButton routerLink="/admin">
                      <mat-icon>account_tree</mat-icon>Admin Home
                    </button>
                    <button matButton [matMenuTriggerFor]="surveyMenu">
                      <mat-icon>settings_suggest</mat-icon>Surveys & Clients
                    </button>
                    <mat-menu #surveyMenu="matMenu">
                      @if (hasAccess(resourceEnum.Admin)) {
                        <button mat-menu-item routerLink="/admin/survey/-1">
                          <mat-icon>add</mat-icon>New Survey
                        </button>
                      }
                      @if (hasAccess(resourceEnum.Admin)) {
                        <button mat-menu-item routerLink="/admin/client/-1">
                          <mat-icon>person_add</mat-icon>New Client
                        </button>
                      }
                      <mat-divider />
                      <button mat-menu-item routerLink="/admin/survey_search">
                        <mat-icon>search</mat-icon>Survey Search
                      </button>
                      <button mat-menu-item routerLink="/admin/client_search">
                        <mat-icon>person_search</mat-icon>Client Search
                      </button>
                      @if (positionSetsFeatureEnabled()) {
                        <mat-divider />
                        <button mat-menu-item routerLink="/admin/position_set_search">
                          <mat-icon>category</mat-icon>Rater Groups
                        </button>
                        <button mat-menu-item routerLink="/admin/position_search">
                          <mat-icon>list_alt</mat-icon>Rater Types
                        </button>
                      }
                    </mat-menu>
                    @if (hasAccess(resourceEnum.Admin)) {
                      <button matButton [matMenuTriggerFor]="questionMenu">
                        <mat-icon>quiz</mat-icon>Questionnaires
                      </button>
                    }
                    <mat-menu #questionMenu="matMenu">
                      <button mat-menu-item [matMenuTriggerFor]="questionnaireMenu">
                        <mat-icon>quiz</mat-icon>Questionnaires
                      </button>
                      <button mat-menu-item routerLink="/question/answer_manage">
                        <mat-icon>rate_review</mat-icon>Answer Types
                      </button>
                      <button mat-menu-item routerLink="/question/category_search">
                        <mat-icon>category</mat-icon>Categories
                      </button>
                    </mat-menu>
                    <mat-menu #questionnaireMenu="matMenu">
                      <button mat-menu-item routerLink="/question/questionnaire_search">
                        <mat-icon>quiz</mat-icon>Search Questionnaires
                      </button>
                      <button mat-menu-item routerLink="/question/questionnaire/-1">
                        <mat-icon>add</mat-icon>New Questionnaire
                      </button>
                    </mat-menu>
                    <button matButton routerLink="/admin/report">
                      <mat-icon>summarize</mat-icon>Reporting
                    </button>
                    @if (hasAccess(resourceEnum.Admin)) {
                      <button matButton [matMenuTriggerFor]="adminUserMenu">
                        <mat-icon>manage_accounts</mat-icon>Users
                      </button>
                    }
                    <mat-menu #adminUserMenu="matMenu">
                      <button mat-menu-item routerLink="/admin/admins">
                        <mat-icon>admin_panel_settings</mat-icon>System & Account Admins
                      </button>
                      <button mat-menu-item routerLink="/admin/clientadmins">
                        <mat-icon>badge</mat-icon>Client Admins
                      </button>
                    </mat-menu>
                    @if (isSysAdmin()) {
                      <button matButton routerLink="/admin/feature-flags">
                        <mat-icon>flag</mat-icon>Feature Flags
                      </button>
                    }
                  </span>
                }
                @if (isClient()) {
                  <span>
                    <button matButton routerLink="/client">
                      <mat-icon>rule</mat-icon>Client Home
                    </button>
                    @if (isClientOnly()) {
                      <button matButton routerLink="/client/report">
                        <mat-icon>summarize</mat-icon>Reporting
                      </button>
                    }
                  </span>
                }
                <span>
                  @if (isParticipant()) {
                    <button matButton routerLink="/participant">
                      <mat-icon>supervised_user_circle</mat-icon>Participant Home
                    </button>
                  }
                </span>
              </div>
            </div>

            <!-- Mobile Menu Button -->
            <div class="block md:hidden">
              <button
                matIconButton
                [matMenuTriggerFor]="dropMenu"
                aria-label="Open navigation menu"
              >
                <mat-icon>menu</mat-icon>
              </button>
            </div>

            <span class="spacer"></span>

            <!-- User Profile Section -->
            <div>
              @if (!isRater()) {
                <span>
                  <button class="user-name" matButton [matMenuTriggerFor]="profileUserMenu">
                    {{ user.appUser.firstName }} {{ user.appUser.lastName }}&nbsp;
                    <mat-icon>expand_more</mat-icon>
                  </button>
                  <mat-menu #profileUserMenu="matMenu">
                    <button mat-menu-item (click)="profile()">
                      <mat-icon color="accent">person</mat-icon>Update Profile
                    </button>
                    <button mat-menu-item (click)="changePassword()">
                      <mat-icon color="accent">password</mat-icon>Change Password
                    </button>
                  </mat-menu>
                </span>
              } @else {
                <span class="user-name"
                  >{{ user.appUser.firstName }} {{ user.appUser.lastName }}</span
                >
              }
              <span class="pl-4">
                <button matIconButton matTooltip="Logout" (click)="logout()" aria-label="Logout">
                  <mat-icon>logout</mat-icon>
                </button>
              </span>
            </div>
          }
        </mat-toolbar-row>
      </mat-toolbar>
    }

    <!-- Mobile Dropdown Menu -->
    <mat-menu #dropMenu="matMenu" class="lighthouse-dropdown">
      <!-- Rater Section -->
      @if (isRater()) {
        <button class="lighthouse-dropdown__link" mat-menu-item routerLink="/rater">
          <mat-icon>dashboard</mat-icon>&nbsp;Survey Dashboard
        </button>
      }

      <!-- Admin Section -->
      @if (hasAccess(resourceEnum.Admin, rightsEnum.Read)) {
        <button class="lighthouse-dropdown__link" mat-menu-item routerLink="/admin">
          <mat-icon>account_tree</mat-icon>Admin Home
        </button>
        <button
          class="lighthouse-dropdown__link"
          mat-menu-item
          [matMenuTriggerFor]="mobileSurveyMenu"
        >
          <mat-icon>settings_suggest</mat-icon>Surveys & Clients
        </button>
        @if (hasAccess(resourceEnum.Admin)) {
          <button
            class="lighthouse-dropdown__link"
            mat-menu-item
            [matMenuTriggerFor]="mobileQuestionMenu"
          >
            <mat-icon>quiz</mat-icon>Questionnaires
          </button>
        }
        <button class="lighthouse-dropdown__link" mat-menu-item routerLink="/admin/report">
          <mat-icon>summarize</mat-icon>Reporting
        </button>
        @if (hasAccess(resourceEnum.Admin)) {
          <button
            class="lighthouse-dropdown__link"
            mat-menu-item
            [matMenuTriggerFor]="mobileUserMenu"
          >
            <mat-icon>manage_accounts</mat-icon>Users
          </button>
        }
        @if (isSysAdmin()) {
          <button class="lighthouse-dropdown__link" mat-menu-item routerLink="/admin/feature-flags">
            <mat-icon>flag</mat-icon>Feature Flags
          </button>
        }
      }

      <!-- Client Section -->
      @if (isClient()) {
        <button class="lighthouse-dropdown__link" mat-menu-item routerLink="/client">
          <mat-icon>rule</mat-icon>Client Home
        </button>
        @if (isClientOnly()) {
          <button class="lighthouse-dropdown__link" mat-menu-item routerLink="/client/report">
            <mat-icon>summarize</mat-icon>Reporting
          </button>
        }
      }

      <!-- Participant Section -->
      @if (isParticipant()) {
        <button class="lighthouse-dropdown__link" mat-menu-item routerLink="/participant">
          <mat-icon>supervised_user_circle</mat-icon>Participant Home
        </button>
      }
    </mat-menu>

    <!-- Mobile Sub-menus for Admin -->
    <mat-menu #mobileSurveyMenu="matMenu">
      @if (hasAccess(resourceEnum.Admin)) {
        <button mat-menu-item routerLink="/admin/survey/-1">
          <mat-icon>add</mat-icon>New Survey
        </button>
        <button mat-menu-item routerLink="/admin/client/-1">
          <mat-icon>person_add</mat-icon>New Client
        </button>
        <mat-divider />
      }
      <button mat-menu-item routerLink="/admin/survey_search">
        <mat-icon>search</mat-icon>Survey Search
      </button>
      <button mat-menu-item routerLink="/admin/client_search">
        <mat-icon>person_search</mat-icon>Client Search
      </button>
      @if (positionSetsFeatureEnabled()) {
        <mat-divider />
        <button mat-menu-item routerLink="/admin/position_set_search">
          <mat-icon>category</mat-icon>Rater Groups
        </button>
        <button mat-menu-item routerLink="/admin/position_search">
          <mat-icon>list_alt</mat-icon>Rater Types
        </button>
      }
    </mat-menu>

    <mat-menu #mobileQuestionMenu="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="mobileQuestionnaireMenu">
        <mat-icon>quiz</mat-icon>Questionnaires
      </button>
      <button mat-menu-item routerLink="/question/answer_manage">
        <mat-icon>rate_review</mat-icon>Answer Types
      </button>
      <button mat-menu-item routerLink="/question/category_search">
        <mat-icon>category</mat-icon>Categories
      </button>
    </mat-menu>

    <mat-menu #mobileQuestionnaireMenu="matMenu">
      <button mat-menu-item routerLink="/question/questionnaire_search">
        <mat-icon>quiz</mat-icon>Search Questionnaires
      </button>
      <button mat-menu-item routerLink="/question/questionnaire/-1">
        <mat-icon>add</mat-icon>New Questionnaire
      </button>
    </mat-menu>

    <mat-menu #mobileUserMenu="matMenu">
      <button mat-menu-item routerLink="/admin/admins">
        <mat-icon>admin_panel_settings</mat-icon>System & Account Admins
      </button>
      <button mat-menu-item routerLink="/admin/clientadmins">
        <mat-icon>badge</mat-icon>Client Admins
      </button>
    </mat-menu>
  </div>
</header>
